export const cancelamentoUserConstants = {
  CANCELAMENTO_USER_REQUEST: 'CANCELAMENTO_USER_REQUEST',
  CANCELAMENTO_USER_SUCCESS: 'CANCELAMENTO_USER_SUCCESS',
  CANCELAMENTO_USER_FAILURE: 'CANCELAMENTO_USER_FAILURE',
};
